import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const useDegradation = (race, session, drivers, hideSlowLaps) => {
  const { user, getIdToken } = useAuth();
  const userId = user?.userId ?? null;
  const driversKey = (drivers || []).slice().sort().join(',');
  const [state, setState] = useState({
    status: 'idle',
    slopes: [],
    raceCount: 0,
  });

  useEffect(() => {
    if (!race || !session) {
      setState({ status: 'idle', slopes: [], raceCount: 0 });
      return;
    }
    let cancelled = false;
    setState((prev) => ({ ...prev, status: 'loading' }));
    (async () => {
      try {
        const token = await getIdToken();
        const params = new URLSearchParams();
        params.set('race', race);
        params.set('session', session);
        if (driversKey) params.set('drivers', driversKey);
        if (hideSlowLaps) params.set('hideSlowLaps', '1');
        const url = `${API_BASE}/api/degradation?${params.toString()}`;
        const res = await fetch(url, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const body = await res.json();
        if (cancelled) return;
        setState({
          status: 'ready',
          slopes: body.slopes || [],
          raceCount: body.raceCount || 0,
        });
      } catch (err) {
        console.error('Failed to load degradation:', err);
        if (!cancelled) {
          setState({ status: 'error', slopes: [], raceCount: 0 });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [race, session, driversKey, hideSlowLaps, userId, getIdToken]);

  return state;
};
